/* eslint-disable */
import { useState, useEffect }          from 'react';
import { createPortal }                 from 'react-dom';
import { ReactComponent as UrlIcon }    from 'assets/images/product-card-arrow.svg'
import { ReactComponent as LearnIcon }  from 'assets/images/right-up-arrow.svg'
import productUrls                      from 'app/common/constants/product-urls';
import appStoreBadge                    from 'assets/images/badges/app-store-badge.svg';
import microsoftBadge                   from 'assets/images/badges/microsoft-badge.svg';
import linuxBadge                       from 'assets/images/badges/linux-badge.svg';
import googlePlayBadge                  from 'assets/images/badges/google-play-badge.svg';
import AuthorizationContext             from 'auth/keycloak-instance';
import Button                           from 'app/common/uikit/button';
import useTranslate                     from 'app/common/hooks/translate';
import {
    useSelector,
    shallowEqual
}                                       from 'react-redux';

const Product = props => {
    const [ showPosDialog, setShowPosDialog ] = useState(false);
    const [ showInactiveTip, setShowInactiveTip ] = useState(false);
    const redux         = useSelector( state => ({
            displayLanguage                : state.provider.displayLanguage
        }), shallowEqual
    );

    const {
        item,
        index,
        isAvailable,
        status
    }               = props;
    const t         = useTranslate();

    const mobileAndTabletCheck = () => {
        const toMatch = [
            /Android/i,
            /webOS/i,
            /iPhone/i,
            /iPad/i,
            /iPod/i,
            /BlackBerry/i,
            /Windows Phone/i
        ];
        
        return toMatch.some((toMatchItem) => {
            return navigator.userAgent.match(toMatchItem);
        });
    };

    const getProductUrl = () => {
        const isMobile = mobileAndTabletCheck();
        const urlResource = isMobile ? 'mobile' : 'desktop';
        const appEnv = window.REACT_APP_ENV || process.env.REACT_APP_ENV || 'test';

        return productUrls?.[appEnv]?.[item.name]?.[urlResource] || item.url ;
    }

    const getProductLandingUrl = () => {
        return !isAvailable ? item.landing : getProductUrl();
    }

    const isPosAppOnly = () => {
        return item.name === 'pos'
            && !AuthorizationContext.user.allProducts.includes('pos');
    }

    const isInactive = () => {
        return isAvailable
            && AuthorizationContext.user.inactiveProducts.includes(item.name);
    }

    // touch devices have no hover, so a tap reveals the tooltip instead
    useEffect(() => {
        if (!showInactiveTip) return;

        const timer = setTimeout( () => setShowInactiveTip(false), 3000 );

        return () => clearTimeout(timer);
    }, [ showInactiveTip ]);

    const posDownloads = [
        { key: 'appstore',   label: 'App Store',   badge: appStoreBadge,   os: ['ios', 'macos'], url: 'https://apps.apple.com/tr/app/simpra-pos-cloud-based-rms/id1356460037' },
        { key: 'googleplay', label: 'Google Play', badge: googlePlayBadge, os: ['android'],       url: 'https://play.google.com/store/apps/details?id=com.protein.rms.pos' },
        { key: 'microsoft',  label: 'Microsoft',   badge: microsoftBadge,  os: ['windows'],       url: 'https://distribution.simprasuite.com/download/file/0355fdc3-4494-487a-9b8f-4136c7a9cb52' },
        { key: 'linux',      label: 'Linux',       badge: linuxBadge,      os: ['linux'],         url: 'https://s3.eu-central-1.amazonaws.com/web-v3-production.simprasuite.com/5.3.93/Simpra-WebPOS-5.3.93-linux-x86_64.AppImage' },
    ];

    const osLabels = {
        macos   : 'macOS',
        windows : 'Windows',
        linux   : 'Linux',
        ios     : 'iOS',
        android : 'Android',
    };

    const detectOs = () => {
        const ua = navigator.userAgent || '';
        if (/android/i.test(ua))            return 'android';
        if (/iphone|ipad|ipod/i.test(ua))   return 'ios';
        if (/win/i.test(ua))                return 'windows';
        if (/mac/i.test(ua))                return 'macos';
        if (/linux/i.test(ua))              return 'linux';
        return null;
    }

    const renderPosDownloads = () => {
        const currentOs = detectOs();
        const primary   = posDownloads.find( item => item.os.includes(currentOs) );
        const others    = posDownloads.filter( item => item !== primary );

        return (
            <div className="pos-downloads">
                {
                    primary
                        ?   <div className="pos-downloads-primary">
                                <span className="pos-downloads-recommended">
                                    { t('Recommended_For_Device') }
                                    <b>{ osLabels[currentOs] }</b>
                                </span>
                                <a className="badge primary" href={ primary.url } target="_blank" rel="noreferrer">
                                    <img src={ primary.badge } alt={ primary.label } />
                                </a>
                            </div>
                        :   null
                }
                {
                    primary
                        ?   <span className="pos-downloads-divider">{ t('Other_Platforms') }</span>
                        :   null
                }
                <div className={ `badge-others${!primary ? ' full' : ''}` }>
                    {
                        others.map( item => (
                            <a className="badge" href={ item.url } target="_blank" rel="noreferrer" key={ item.key }>
                                <img src={ item.badge } alt={ item.label } />
                                <span className="badge-label">{ item.label }</span>
                            </a>
                        ))
                    }
                </div>
            </div>
        )
    }

    const renderStatusBadge = () => {
        if (isInactive()) return null;
        if (!status || !status.statusText || status.statusText === 'UNKNOWN') return null;

        const labels = {
            OPERATIONAL : t('Status_Operational'),
            DEGRADED    : t('Status_Degraded'),
            INCIDENT    : t('Status_Down'),
        };

        return (
            <a
                className   = { `product-status ${status.statusText.toLowerCase()}` }
                href        = { status.url }
                target      = "_blank"
                rel         = "noreferrer"
                title       = { labels[status.statusText] }
                onClick     = { e => e.stopPropagation() }
            >
                <span className="status-dot" />
                <span className="status-label">{ labels[status.statusText] }</span>
            </a>
        )
    }

    const handleProductClick = e => {
        if (isInactive()) {
            e.preventDefault();
            setShowInactiveTip(true);
            return;
        }
        if (isPosAppOnly()) {
            e.preventDefault();
            setShowPosDialog(true);
            return;
        }
        props.toggleApplicationLoader(getProductUrl());
    }

    const renderHelperButton = () => {
        if (isInactive()) return null;

        { /* eslint-disable-next-line */ }
        return isAvailable
            ?   <a href={ getProductLandingUrl() } target="_blank" rel="noreferrer">
                    <UrlIcon />
                    {/* <div className="tooltip">{ t('Learn_More') }</div> */}
                </a>
            :   <a className="learn-more" href={ getProductLandingUrl() } target="_blank" rel="noreferrer">
                    { t('Learn') }
                    <LearnIcon />
                </a>
    }

    return (
        <div
            className   = { `product${!isAvailable ? ' fixed' : ''}${isInactive() ? ' inactive' : ''}${showInactiveTip ? ' tip-visible' : ''} ${item.name.replace('c&p', 'checkandplace')} item-${index + 1}`} key={ 'pro-' + index }
            style       = {{ minHeight: 141 }}
        >
            { /* eslint-disable-next-line */ }
            <a className="app-link"
                href={ '#' }
                onTouchStart={ e => handleProductClick(e) }
                onClick={ e => handleProductClick(e) }
            />
            <div className={ `icon ${item.name.replace('c&p', 'checkandplace')}` } />
            <div className="name">
                <div>
                    { item.text }
                    <span>{ isAvailable ? t('GoTo_Product') : item.desc[redux.displayLanguage] }</span>
                    <span className="trial-desc">{ t('Start_Trial') } <UrlIcon /></span>
                </div>
            </div>
            <div className={ `url${!isAvailable ? ' fixed' : ''}` }>
                { /* eslint-disable-next-line */ }
                { renderHelperButton() }
            </div>

            { renderStatusBadge() }

            {
                isInactive()
                    ?   <div className="inactive-tooltip">{ t('Product_Inactive_Message') }</div>
                    :   null
            }

            {
                showPosDialog
                    ?   createPortal(
                            <div className="permissions-container pos-app-only" onClick={ () => setShowPosDialog(false) }>
                                <div className="permissions-content-wrapper" onClick={ e => e.stopPropagation() }>
                                    <div className="header">
                                        <h1>{ t('POS_App_Only_Title') }</h1>
                                        <h2>{ t('POS_App_Only_Message') }</h2>
                                    </div>
                                    <div className="permission-content">
                                        { renderPosDownloads() }
                                        <div className="form-row mt30 mb0">
                                            <Button
                                                label       = { t('Close') }
                                                onClick     = { () => setShowPosDialog(false) }
                                                full
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>,
                            document.getElementById('root')
                        )
                    :   null
            }
        </div>
    )
}

export default Product
/* eslint-enable */